<!--
  장비
  Device Context Menu

  @since 2020-12-09
  @author mk.ko
-->

<template>
  <div v-show="showContextMenu && !disableContextMenu"
       ref="contextMenuPopover"
       @contextmenu="$event => $event.stopPropagation()"
  >
    <div ref="contextMenuInnerPopover"
         class="q-popover display-block animate-popup-down context-menu-scroll-wrapper"
         :style="cssContent"
         @contextmenu="$event => $event.preventDefault()"
    >
  <!--  <q-context-menu ref="contextMenuPopover"-->
  <!--                  :no-render="!showContextMenu"-->
  <!--                  :disable="isReadOnly"-->
  <!--                  @click="getContextData($event)"-->
  <!--                  @show="onShow"-->
  <!--                  @hide="onHide"-->
  <!--  >-->

      <!-- TAMS 직접 구현 방식 -->
<!--      <q-list link separator class="context-menu-scroll-area">-->

<!--        &lt;!&ndash; Default context mneu &ndash;&gt;-->
<!--        <q-item v-for="contextMenu in contextMenuList"-->
<!--                :key="contextMenu.type"-->
<!--                :disable="onDisable(contextMenu)"-->
<!--                @click.native="onEvent(contextMenu)">-->
<!--          <q-item-main :label="contextMenu.label"></q-item-main>-->
<!--        </q-item>-->

<!--        &lt;!&ndash; TODO:Custom context menu &ndash;&gt;-->
<!--        <q-item-separator inset v-if="customMenuList" class="separator-item marL5 marR5"/>-->

<!--        <template v-for="customContextMenu in customMenuList">-->
<!--          <q-item-separator inset v-if="customContextMenu.separator" class="separator-item marL5 marR5"/>-->

<!--          <q-item :key="customContextMenu.type"-->
<!--                  :disable="onDisable(customContextMenu)"-->
<!--                  @click.native="onEvent(customContextMenu)">-->
<!--            <q-item-main :label="customContextMenu.label"></q-item-main>-->
<!--          </q-item>-->
<!--        </template>-->

<!--      </q-list>-->

      <!-- Recursive dropdown -->
      <recursive-dropdown :list="mergeContextList"
                          :disable="false"
                          :close-overlay="false"
                          @onClick="onEvent"
      />

    </div>
  </div>

</template>

<script>
  // components
  import RecursiveDropdown from '~/components/control/RecursiveDropdown'

  // mixins
  import DeviceContextMenuMixin from '~/mixins/deviceContextMenuMixin'

  export default {
    name: 'DeviceContextMenu',
    components: {
      RecursiveDropdown
    },
    mixins: [
      DeviceContextMenuMixin
    ],
    data () {
      return {
        showContextMenu: false,
        contextMenuList: [],
        selectedData: {},
        contextMenu: [{label: '', value: '', disable: () => false}],
        target: void 0,
        cssContent: {}
      }
    },
    props: {
      isReadOnly: {
        type: Boolean,
        default: false
      },
      customMenu: {
        type: Array,
        default: () => []
      },
      manualOpen: {
        type: Boolean,
        default: false
      },
      datatable: {
        type: Object,
        default: void 0
      },
      menuDisable: {
        type: [ Function, Boolean ],
        default: _.noop()
      },
      disableContextMenu: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      // TAMS
      // ...commonHelper.mapState({
      //   userLevel: state => state.uiData.user.level
      //   backUp: state => state.backUp
      // }),
      customMenuList () {
        try {
          return this.customMenu
        } catch (e) {
          return []
        }
      },
      isDeviceItemEmpty () {
        try {
          return _.isEmpty(this.selectedData)
        } catch (e) {
          return false
        }
      },
      mergeContextList () {
        try {
          return _.concat(this.customMenuList, this.contextMenuList)
        } catch (e) {
          return []
        }
      }
    },
    beforeDestroy () {
      this.contextMenuList = []

      try {
        if (!this.manualOpen) {
          this.target.removeEventListener('contextmenu', this.show)
        }
        this.target.removeEventListener('click', this.hide)
        document.body.removeEventListener('click', this.hide)
        // document.body.removeEventListener('mousedown', this.hide)
      } catch (e) {}
      this.target = void 0
    },
    created () {
      // this.setContextData()
    },
    mounted () {
      try {
        // this.showContextMenu = !this.manualOpen
        this.setContextMenu()

        const target = _.get(this.$refs, ['contextMenuPopover', 'parentNode'])
        if (target) {
          this.target = target
          if (!this.manualOpen) {
            this.target.addEventListener('contextmenu', this.show)
          }
          this.target.addEventListener('click', this.hide)
          document.body.addEventListener('click', this.hide)
        }
      } catch (e) {
        this.$log('[Device Context Menu GUI Error (mounted)]', e)
      }
    },
    methods: {
      // /**
      //  * 이름: getContextDisable
      //  * 설명: 사용자의 설정 권한이 없거나, Backup 장비인 경우 컨텍스트 메뉴를 비활성화한다.
      //  */
      // getContextDisable (contextMenu) {
      //   if (_.has(contextMenu, 'disable')) {
      //     return contextMenu.disable()
      //   } else {
      //     // TAMS 제외
      //     // if (this.backUp) {
      //     //   if (_.has(contextMenu, 'haForce')) {
      //     //     return false
      //     //   }
      //     //
      //     //   return true
      //     // }
      //
      //     return false
      //   }
      // },
      setContextMenu () {
        this.contextMenuList = [
          {
            separator: Boolean(_.size(this.customMenuList)),
            type: 'ping',
            label: 'Ping',
            click: (item) => {
              window.event.stopPropagation()
              this.onNetworkToolsExec({
                selectedData: this.selectedData,
                menuCode: 160101
              }) // 160101: System - Tools - Ping
              this.$emit('ping')
              this.hide()
            },
            disable: item => (this.isDisableContextMenu('ping', item) || this.isReadOnly)
          },
          {
            type: 'traceroute',
            label: 'Traceroute',
            click: (item) => {
              window.event.stopPropagation()
              this.onNetworkToolsExec({
                selectedData: this.selectedData,
                menuCode: 160201
              }) // 160201: System - Tools - Traceroute
              this.$emit('traceroute')
              this.hide()
            },
            disable: item => (this.isDisableContextMenu('traceroute', item) || this.isReadOnly)
          },
          {
            type: 'guiExec',
            label: this.$t('cmn.guiExec'),
            click: (item) => {
              window.event.stopPropagation()
              this.onGUIExec(this.selectedData)
              this.$emit('guiExec')
              this.hide()
            },
            disable: item => (this.isDisableContextMenu('guiExec', item) || this.isReadOnly)
          }
        ]
      },
      getPosition (e = window.event) {
        try {
          let posx = 0, posy = 0

          if (e.pageX || e.pageY) {
            posx = e.pageX
            posy = e.pageY
          } else if (e.clientX || e.clientY) {
            posx = e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft
            posy = e.clientY + document.body.scrollTop + document.documentElement.scrollTop
          }

          return {
            x: posx,
            y: posy
          }
        } catch (e) {
          this.$log('[Device Context Menu GUI Error (getPosition)]', e)
        }
      },
      async show ({ selectedData = {}, x, y } = {}) {
        try {
          const e = window.event
          let contextData = void 0
          if (this.datatable) {
            contextData = _.get(this.datatable.jsGridExec('getCellData', e), ['rowItem'])
          }

          try {
            e.cancelable !== false && e.preventDefault()
            e.stopPropagation() // 이벤트 버블링 방어
          } catch (e) {}

          // if (this.showContextMenu) {
          //   this.hide()
          //   await this.$nextTick()
          // }
          // this.showContextMenu = true
          // await this.$nextTick()
          if (!this.showContextMenu) {
            this.showContextMenu = true
            await this.$nextTick()
          }

          if (_.isEmpty(selectedData) && !_.isEmpty(contextData)) {
            this.selectedData = contextData
          } else {
            this.selectedData = selectedData
          }

          // document.body.addEventListener('mousedown', this.hide)

          let left = 0, top = 0, posx = 0, posy = 0, setPosition = false
          const
            contextMenuWidth = this.$refs.contextMenuInnerPopover.offsetWidth + 4,
            contextMenuHeight = this.$refs.contextMenuInnerPopover.offsetHeight + 4,
            windowWidth = window.innerWidth,
            windowHeight = window.innerHeight
          if (x && y) {
            posy = y + document.body.scrollTop
            posx = x + document.body.scrollLeft
            setPosition = true
          } else if (typeof window.event !== 'undefined') {
            const
              e = window.event,
              pos = this.getPosition(e)
            posx = pos.x
            posy = pos.y
            setPosition = true
            // this.$refs.contextMenuPopover.outerWidth()

            // this.$nextTick(() => {
            //   setToolTipPosition({
            //     el: this.$refs.contextMenuPopover,
            //     animate: true,
            //     offset: [-40, 0],
            //     anchorEl: this.$refs.contextMenuPopover.parentNode,
            //     anchorOrigin: parsePosition('top left'),
            //     selfOrigin: parsePosition('bottom left')
            //   })
            // })
          }

          if (setPosition) {
            if ((windowWidth - posx) < contextMenuWidth) {
              left = `${windowWidth - contextMenuWidth}px`
            } else {
              left = `${posx}px`
            }
            if ((windowHeight - posy) < contextMenuHeight) {
              top = `${windowHeight - contextMenuHeight}px`
            } else {
              top = `${posy}px`
            }

            this.cssContent = {
              top,
              left,
              maxHeight: '65vh',
              maxWidth: '100vw',
              display: 'block'
            }
          }

          // if (this.manualOpen) {
          //   this.showContextMenu = true
          // }
          // this.$refs.contextMenuPopover.show()
          this.$nextTick(() => {
            this.onShow()
          })
        } catch (e) {
          this.$log('[Device Context Menu GUI Error (show)]', e)
        }
      },
      hide (e) {
        try {
          try {
            window.event.stopPropagation() // 이벤트 버블링 방어
          } catch (e) {}
          // if (this.manualOpen) {
          //   this.showContextMenu = false
          // }
          // this.$refs.contextMenuPopover.hide()
          if (!this.showContextMenu) {
            return
          }

          // document.body.removeEventListener('mousedown', this.hide)
          this.showContextMenu = false

          this.$nextTick(() => {
            this.onHide()
          })
        } catch (e) {
          this.$log('[Device Context Menu GUI Error (hide)]', e)
        }
      },
      onShow () {
        this.$emit('showContextMenu')
      },
      onHide () {
        this.selectedData = {}
        this.showContextMenu = false

        this.$emit('hideContextMenu')
      },
      // getContextData (evt) {
      //   if (!this.manualOpen) {
      //     this.showContextMenu = true
      //   }
      //
      //   this.setContextData()
      // },
      // setContextData () {
      //   // Default context menu
      //   this.contextMenuList = [
      //     {
      //       label: 'Ping',
      //       type: 'ping'
      //     },
      //     {
      //       label: 'Traceroute',
      //       type: 'traceroute'
      //     },
      //     {
      //       label: this.$t('cmn.guiExec'),
      //       type: 'guiExec'
      //     }
      //   ]
      // },
      // getContextEvent (contextMenu) {
      //   if (contextMenu.type === 'ping') {
      //     this.$emit('ping')
      //   } else if (contextMenu.type === 'traceroute') {
      //     this.$emit('traceroute')
      //   } else if (contextMenu.type === 'guiExec') {
      //     this.onGUIExec()
      //   }
      // },
      // getCustomContextEvent (contextMenu) {
      //   try {
      //     this.$emit(contextMenu.type)
      //   } catch (e) {
      //     this.$log('[Device Context Menu GUI Error (getCustomContextEvent)]', e)
      //   }
      // },
      onEvent (item) {
        window.event.stopPropagation() // 이벤트 버블링 방어
        try {
          if (this.onDisable(item) || this.isReadOnly) {
            return void 0
          }

          if (_.isFunction(item.click)) {
            item.click(this.selectedData)
          } else {
            this.$emit(item.type, this.selectedData)
          }
          this.hide()
        } catch (e) {
          this.$log('[Device Context Menu GUI Error (onEvent)]', e)
        }
      },
      onDisable (item) {
        let isDisableFlag = false
        try {
          if (item.disable) {
            if (_.isFunction(item.disable)) {
              isDisableFlag = item.disable(this.selectedData)
            } else {
              isDisableFlag = item.disable
            }
          }
        } catch (e) {
          this.$log('[Device Context Menu GUI Error (onDisable)]', e)
        }
        return isDisableFlag
      },
      isDisableContextMenu (type, item) {
        try {
          let res = false
          switch (type) {
            case 'ping':
            case 'traceroute':
              res = this.isReadOnly || this.isDeviceItemEmpty || this.isDeviceGroupType(this.selectedData.device_type)
              break
            case 'guiExec':
              const supportDeviceModel = [ 20, 21, 22, 23 ] // 20: NGF, 21: NGIPS, 22: WIPS 추후 모델 타입 추가 시 확장 필요, 23: ADS
              res = this.isReadOnly || this.isDeviceItemEmpty || this.isDeviceGroupType(this.selectedData.device_type) || supportDeviceModel.indexOf(this.selectedData.device_model_type) === -1
              break
          }

          let menuDisable = false
          if (typeof this.menuDisable !== 'undefined') {
            if (typeof this.menuDisable === 'function') {
              menuDisable = this.menuDisable(type, item)
            }
            if (typeof this.menuDisable === 'boolean') {
              menuDisable = this.menuDisable
            }
          }
          return res || menuDisable
        } catch (e) {
          this.$log('[Device Context Menu GUI Error (isDisableContextMenu)]', e)
          return false
        }
      }
    }
  }
</script>

<style scoped>
  .context-menu-scroll-wrapper {
    overflow: hidden;
    /*padding-right: 10px;*/
  }
  .context-menu-scroll-area {
    overflow-y: auto;
    max-height: 65vh;
    max-width: 100vw;
    padding-right: -10px;
  }
  .context-menu-scroll-area::-webkit-scrollbar { width: 10px; height: 8px; } /* TAMS */
  .context-menu-scroll-area::-webkit-scrollbar-track {
    background-color: #e5e5e5;
  }
  .context-menu-scroll-area::-webkit-scrollbar-thumb {
    background-color: #85acd6;
    /*border-radius: 3px;*/ /* TAMS */
}
  .separator-item {
    /*border-top: 1px solid #a4c6ec !important;*/
    border-top: 1px solid #0061cc !important;
  }
</style>
